import { createInstance } from '@/helpers/api/base'
import { ControlSheetDTO } from '@/types/controlsheet'
import { QueryObserverResult, RefetchOptions, useQuery } from '@tanstack/react-query'

const CONTROL_SHEETS_KEY = 'CONTROL_SHEETS'

export interface ControlSheetData {
    data: ControlSheetDTO[] | undefined
    isLoading: boolean
    refetch: (options?: RefetchOptions | undefined) => Promise<QueryObserverResult<ControlSheetDTO[], Error>>
    dataUpdatedAt: number | undefined
}

export const useGetControlSheets = (date: string, routes: string[]): ControlSheetData => {
    const uq = useQuery({
        queryKey: [CONTROL_SHEETS_KEY, date, routes.sort().join(',')],
        queryFn: () =>
            createInstance<ControlSheetDTO[]>({
                url: '/control-sheets/routes',
                method: 'GET',
                params: {
                    Date: date,
                    Routes: routes,
                },
                paramsSerializer: {
                    indexes: null,
                },
            }),
        enabled: Boolean(date && routes.length > 0),
        staleTime: Infinity,
    })
    return uq
}
